import { PaginationProps } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import WorkshiftTable from 'components/tables/workshift_table';
import useMember from 'hooks/useMember';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const WorkshiftCalendar = () => {
  const { workShiftListFilter, getFilterWorkShiftCalendars } = useMember();
  const navigate = useNavigate();
  const [state, setState] = useState({
    name: null,
    description: null,
    hours_per_week: null,
    page: '1',
    page_size: '10',
    count: null,
    currentPage: 1,
  });

  const {
    name,
    description,
    hours_per_week,
    count,
    currentPage,
    page,
    page_size,
  } = state;

  const onChangeName = useCallback(
    debounce((value) => {
      setState((pre) => ({
        ...pre,
        name: value,
        page: '1',
      }));
    }, 500),
    [],
  );

  const onChange = (pageNumber) => {

    setState((pre) => ({
      ...pre,
      page: pageNumber,
    }));
  };

  const onChangeDescription = useCallback(
    debounce((value) => {
      setState((pre) => ({
        ...pre,
        description: value,
        page: '1',
      }));
    }, 500),
    [],
  );
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return <a className="mr-3">Next</a>;
    }

    return originalElement;
  };

  const onChangeHoursPerWeek = useCallback(
    debounce((value) => {
      if (value.includes(':')) {
        const [hoursPart, minutesPart] = value.split(':').map((part) => parseInt(part, 10) || 0);
        const seconds = hoursPart * 3600 + minutesPart * 60;
        setState((pre) => ({
          ...pre,
          hours_per_week: seconds,
          page: '1',
        }));
      } else {
        const hours = parseInt(value, 10) || 0;
        const seconds = hours * 3600;
        setState((pre) => ({
          ...pre,
          hours_per_week: seconds,
          page: '1',
        }));
      }
    }, 500),
    [],
  );

  useEffect(() => {
    getFilterWorkShiftCalendars({
      ...(description && { description: description }),
      ...(name && { name: name }),
      ...(hours_per_week && { hours_per_week: hours_per_week }),
      ...(page && { page: page }),
      ...(page_size && { page_size: page_size }),
    }).then((res) => {

      setState((pre) => ({
        ...pre,
        count: res?.data?.count,
        currentPage: res?.data?.page,
      }));
    });
  }, [name, description, hours_per_week, page]);
  return (
    <div>
      <GeneralHeader
        icon={'/icons/work_shift.svg'}
        pageTitle={'Work Shift Calendars'}
        btnComponent={
          <button
            onClick={() =>
              navigate('/general_settings/new_work_shift_calendar')
            }
            className="header-button"
            style={{ width: 260 }}
          >
            <img src="/icons/add_button.svg" alt="button" />
            New work shift calendar
          </button>
        }
        child={
          <div style={{ marginTop: '30px', paddingBottom: '100px' }}>
            <section className={'function_container'}>
              <div
                style={{ background: 'white', padding: '10px 0px 10px 0px' }}
                className={'function_wrapper'}
              >
                <div>
                  <WorkshiftTable
                    onChangeDescription={onChangeDescription}
                    onChangeName={onChangeName}
                    onChangeHoursPerWeek={onChangeHoursPerWeek}
                    data={workShiftListFilter}
                    onChange={onChange}
                    itemRender={itemRender}
                    currentPage={currentPage}
                    count={count}
                  />
                </div>
              </div>
            </section>
          </div>
        }
      />
    </div>
  );
};

export default WorkshiftCalendar;
